module.exports = __webpack_public_path__ + "./fonts/fontawesome-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/fontawesome-webfont.ttf?v=4.6.3
// module id = 17
// module chunks = 0